<template>
<div class="menu" style="z-index:100">
        <!-- Home menu -->
        <div class="home-menu-outer" v-if="this.current == 0" >
        <!--inner LV -->
        <div class="inner">
            <a ><img @click="setLanguage(1)" src="../assets/zimes/lv.png"></a>
            <a ><img @click="setLanguage(2)" src="../assets/zimes/eng.png"></a>         
        </div>
        </div> 

        <div class="home-menu-outer" v-if="this.current == 1" >
        <!--inner LV -->
        <div class="inner">
            <a ><img @click="slide(0)" src="../assets/zimes/home.png"></a>
                    
        </div>
        </div> 
</div>


   
</template>
<script>


export default
{
    data: function () {
    return {
      current: 0,
      showMenu:0,
      language:1,
      sub:false,
    }},
    created()
      {
          
          this.$eventHub.$on('slide-changed', (count) =>
          {
              this.showMenu = 0;
              this.current = count;
          });
          this.$eventHub.$on('subOpen', () =>
          {
              this.sub = true;
          });
          this.$eventHub.$on('subClose', () =>
          {
              this.sub = false;
          });
    
      },
        methods:
  {
      menu: function()
      {
          if (this.showMenu == 0)  
          {
              this.showMenu = 1
          }
          else
          {
              this.showMenu = 0
          }
      },
      nextSlide: function()
      {
          this.showMenu = 0;
          this.$eventHub.$emit('next-slide', this.current+1);
          this.sub = false;
      },
      prevSlide: function()
      {
            this.showMenu = 0;
          this.$eventHub.$emit('prev-slide', this.current - 1);
          this.sub = false;
      },
      homeSlide: function()
      {
          this.showMenu = 0;
          this.current = 0;
          this.$eventHub.$emit('home-slide', 0);
          this.sub = false;
      },
      slide: function(n)
      {
          this.showMenu = 0;
          this.current = n;
          this.$eventHub.$emit('slide', n);
          this.sub = false;
      },
      setLanguage: function(val)
      {
          this.language = val;
          this.$eventHub.$emit('language', val);
          
      }
         
  
    
}


}
</script>
<style lang="scss">

.home-menu-outer
{
     position:absolute;
      bottom:25px;
      width:100%;
      text-align:center;
    width:100%;
    text-align:center;
    .inner{
        padding:7px;
        padding-left:50px;
        padding-right:50px;
        border-radius: 40px;
        display:inline-block;
        background-color:rgba(203,196,192, 1);
    }
    a>img{
        padding-left:10px;
        padding-right:10px;
        vertical-align:middle;
    }

}
</style>